import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class TextQuestion extends Component {
    render() {
        const {
            textQuestionValue,
            onFocus,
            onAnswerUpdate,
            question,
            hasError,
            inputId,
            ...rest
        } = this.props;

        const inputWrapClassName = classNames('input', 'input--inset', {
            ['input--error']: hasError
        })

        return(
            <div className={inputWrapClassName}>
                <input className="input__control" type="text"
                    id={inputId}
                    name="text_question"
                    value={textQuestionValue}
                    onChange={this.onAnswerUpdate}
                    placeholder="Your answer here"
                    onFocus={this.onFocus}
                    {...rest}
                />
            </div>
        )

    }

    onFocus = (e) => {
        if(this.props.onFocus) {
            this.props.onFocus(e, this.props.question);
        }
    }

    onAnswerUpdate = (e) => {
        this.props.onAnswerUpdate(e.target.value);
    }
}

TextQuestion.propTypes = {
    textQuestionValue: PropTypes.string,
    onAnswerUpdate: PropTypes.func.isRequired
}

export default TextQuestion;
